<div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
<div class='alert alert-danger malert-danger' *ngIf="err_validation">{{ err }}</div>
<div class='alert alert-danger malert-danger' *ngIf="err_internet_validation">{{ err_internet_text }} <span><i class="fas fa-sync icon" ></i></span></div>

<div mat-dialog-title class="matDialogTitle">
  <div class="container-fluit"> 
    <div class="row"> 
      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
      <span> {{ title }} </span>
      <span class="close" (click)="close()" ><mat-icon>close</mat-icon></span>
      </div>
    </div><!-- row -->
  </div><!-- container-fluit -->
</div>

<div mat-dialog-content class="matDialogContent">
  <form #form_myModal="ngForm">
      <div style='text-align:center;padding:12px !important'>
      </div>
      <div class="row">
        <div class='col-md-4 col-lg-4 col-sm-4 col-xs-12 pe'>
        <label for="title" class='wh-label'>  
          <span> عنوان :  </span>
          <input class='wh-input' name='title' [(ngModel)]='title'   pattern="[{{ pattern_title_with_persian }}]{1,}"  autocomplete="off" required>
        </label>
        </div>

        <div class='col-md-4 col-lg-4 col-sm-4 6 col-xs-12 pe'>
            <label for="hover1" class='wh-label'>  
              <span> هاور اول :  </span>
              <input class='wh-input' name='hover1' [(ngModel)]='hover1'   pattern="[{{ pattern_title_with_persian }}]{1,}"  autocomplete="off">
            </label> 
          </div>
          <div class='col-md-4 col-lg-4 col-sm-4 6 col-xs-12 pe'>
              <label for="hover2" class='wh-label'>  
                <span> هاور دوم :  </span>
                <input class='wh-input' name='hover2' [(ngModel)]='hover2'   pattern="[{{ pattern_title_with_persian }}]{1,}"  autocomplete="off">
              </label>
          </div>
          <div class='col-md-4 col-lg-4 col-sm-4 6 col-xs-12 pe'>
            <label for="hover3" class='wh-label'>  
              <span> هاور سوم :  </span>
              <input class='wh-input' name='hover3' [(ngModel)]='hover3'   pattern="[{{ pattern_title_with_persian }}]{1,}"  autocomplete="off">
            </label>
          </div>
          <div class='col-md-4 col-lg-4 col-sm-4 6 col-xs-12 pe'>
            <label for="title" class='wh-label'>  
              <span>  شعار :  </span>
              <input class='wh-input' name='sho' [(ngModel)]='sho'   pattern="[{{ pattern_title_with_persian }}]{1,}"  autocomplete="off">
            </label>
          </div>
          <div class='col-md-4 col-lg-4 col-sm-4 6 col-xs-12 pe'>
              <label for="title" class='wh-label'>  
                <span>  واحد پولی :  </span>
                <input class='wh-input' name='currency' [(ngModel)]='currency'   pattern="[{{ pattern_title_with_persian }}]{1,}"  autocomplete="off">
              </label>
          </div>

          <div class='col-md-4 col-lg-4 col-sm-4 6 col-xs-12 pe'>
            <label for="title" class='wh-label'>  
              <span>   تخفیف :  </span>
              <input class='wh-input' name='discount_festival' [(ngModel)]='discount_festival'   pattern="[0-9]{1,}"  autocomplete="off">
            </label>
          </div>
        
        <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe'>
          <label for="title" class='wh-label'>  
          <span>  توضیحات :  </span>
          <textarea class='wh-input' name='comment' [(ngModel)]='comment'  [innerHTML]="comment"   autocomplete="off" style="height:150px"></textarea>
          </label>
        </div>

        <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe'>
            <label for="title" class='wh-label'>  
            <span> متن قرارداد :  </span>
            <textarea class='wh-input' name='contract' [(ngModel)]='contract'  [innerHTML]="contract"  autocomplete="off" style="height:150px"></textarea>
            </label>
        </div>
      
        <div class='col-md-2 col-lg-2 col-sm-2 col-xs-12 pe' >
          <label for="status_id" class='wh-label'>    
            <span> وضعيت نمايش :  </span>
            <select class='wh-input' name='status_id' [(ngModel)]='status_id'    pattern="[0-9]{1,}" required>
            <option value=""></option>   
            <option *ngFor='let x of list_status' value="{{ x.status_id }}">
              <span>{{ x.status_title2 }}</span>
              </option>
            </select>
          </label> 
        </div> 
      </div>  
      <div class="row">
        <div *ngFor="let x of list_process" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 pe" style="font-size: 12px">
          <input type="checkbox" style="vertical-align: bottom;margin:1px" value="{{ x.sale_process_id }}" name="process[]" [checked]="x.process_check == 1 ">{{ x.sale_process_title }}
        </div>
      </div>
  </form>
  <div class="row">
    <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12" style="float:right">
      <form class="upload_form  pe"   id="file-form" runat="server" (ngSubmit)="upload_submit('input-select-1',1,'alarm1',3,1)">
        <div class="upload_format">فرمت مورد قبول:فقط تصویر </div>
        <input type='file'  style='display:none'  id='input-select-1' (change)="change_input('input-select-1','upload-button-1','image-1','image',200)">
        <button type="submit" id='upload-button-1' style='display:none'></button>
        <label  (click)="div_select_file('input-select-1')">
          <img src='{{ shop_menu_shop_site }}/{{ shop_menu_shop_attachment1 }}' class='img-file' id='image-1' style="width:200px !important;height:200px">
          <div class="upload_alarm" id='alarm1' style="display: none;width:100%">در حال بارگذاری..</div>
        </label>
      </form>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12"  style="float:right">
      <form class="upload_form  pe"   id="file-form" runat="server" (ngSubmit)="upload_submit('input-select-2',2,'alarm2',3,2)">
        <div class="upload_format">فرمت مورد قبول:فقط تصویر </div>
        <input type='file'  style='display:none'  id='input-select-2' (change)="change_input('input-select-2','upload-button-2','image-2','image',200)">
        <button type="submit" id='upload-button-2' style='display:none'></button>
        <label  (click)="div_select_file('input-select-2')">
          <img src='{{ shop_menu_shop_site }}/{{ shop_menu_shop_attachment2 }}' class='img-file' id='image-2' style="width:200px !important;height:200px">
          <div class="upload_alarm" id='alarm2' style="display: none;width:100%">در حال بارگذاری..</div>
        </label>
      </form>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12"  style="float:right">
      <form class="upload_form  pe"  id="file-form" runat="server" (ngSubmit)="upload_submit('input-select-3',3,'alarm3',3,3)">
        <div class="upload_format">فرمت مورد قبول:فقط تصویر </div>
        <input type='file'  style='display:none'  id='input-select-3' (change)="change_input('input-select-3','upload-button-3','image-3','image',200)">
        <button type="submit" id='upload-button-3' style='display:none'></button>
        <label  (click)="div_select_file('input-select-3')">
          <img src='{{ shop_menu_shop_site }}/{{ shop_menu_shop_attachment3 }}' class='img-file' id='image-3' style="width:200px !important;height:200px">
          <div class="upload_alarm" id='alarm3' style="display: none;width:100%">در حال بارگذاری..</div>
        </label>
      </form>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12"  style="float:right">
      <form class="upload_form  pe"   id="file-form" runat="server" (ngSubmit)="upload_submit('input-select-4',4,'alarm4',3,4)">
        <div class="upload_format">فرمت مورد قبول:فقط تصویر </div>
        <input type='file'  style='display:none'  id='input-select-4' (change)="change_input('input-select-4','upload-button-4','image-4','image',200)">
        <button type="submit" id='upload-button-4' style='display:none'></button>
        <label  (click)="div_select_file('input-select-4')">
          <img src='{{ shop_menu_shop_site }}/{{ shop_menu_shop_attachment4 }}' class='img-file' id='image-4' style="width:200px !important;height:200px">
          <div class="upload_alarm" id='alarm4' style="display: none;width:100%">در حال بارگذاری..</div>
        </label>
      </form>
    </div>
    </div><!-- row -->
    <div class="row">
    <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12"  style="float:right">
      <form class="upload_form  pe"   id="file-form" runat="server" (ngSubmit)="upload_submit('input-select-5',5,'alarm5',3,5)">
        <div class="upload_format">فرمت مورد قبول:فقط تصویر </div>
        <input type='file'  style='display:none'  id='input-select-5' (change)="change_input('input-select-5','upload-button-5','image-5','image',200)">
        <button type="submit" id='upload-button-5' style='display:none'></button>
        <label  (click)="div_select_file('input-select-5')">
          <img src='{{ shop_menu_shop_site }}/{{ shop_menu_shop_attachment5 }}' class='img-file' id='image-5' style="width:200px !important;height:200px">
          <div class="upload_alarm" id='alarm5' style="display: none;width:100%">در حال بارگذاری..</div>
        </label>
      </form>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12"  style="float:right">
      <form class="upload_form  pe"  id="file-form" runat="server" (ngSubmit)="upload_submit('input-select-6',6,'alarm5',3,6)">
        <div class="upload_format">فرمت مورد قبول:فقط تصویر </div>
        <input type='file'  style='display:none'  id='input-select-6' (change)="change_input('input-select-6','upload-button-6','image-6','image',200)">
        <button type="submit" id='upload-button-6' style='display:none'></button>
        <label  (click)="div_select_file('input-select-6')">
          <img src='{{ shop_menu_shop_site }}/{{ shop_menu_shop_attachment6 }}' class='img-file' id='image-6' style="width:200px !important;height:200px">
          <div class="upload_alarm" id='alarm6' style="display: none;width:100%">در حال بارگذاری..</div>
        </label>
      </form>
    </div>
  <br><br><br>
</div>


<div mat-dialog-actions class="matDialogActions">
  <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12' style='margin-top:5px;text-align:center'>
  <button mat-raised-button class="btn"   (click)="update()"  [disabled]="!form_myModal.valid">ويرايش</button> 
  </div> 
</div>
